export default function positionColor(PersonaCollection) {
  'ngInject';

  return function link($scope, $element, $attrs) {
    $scope.$watch(
      () => $scope.$eval($attrs.positionColor)?.id,
      (positionId) => {
        const prop = $attrs.positionColorProp || 'background-color';
        $element.css(prop, PersonaCollection.personasDict[positionId]?.color);
      }
    );
  };
}
